import { Menu, MenuItem, MenuDivider } from '@/common/ui/Menu'

import { Icon, type IconName } from '@/common/ui/Icon'
import { NavLink } from 'react-router-dom'
import { Button } from '@/common/ui/Form/Button'
import { DropdownMenu } from '@/common/ui/Dropdown'
import { useMe } from '@/common/entities/me/model/me'
import { useCurrentOrg, useMyOrgs } from '../../org/model'
import { Modal } from '@/common/ui/Modal'
import { SelectOrg } from '@/app/entities/org/ui/SelectOrg'
import { AddOrgForm } from '@/app/entities/org/ui/AddOrgForm'
import { useLogout } from '../../auth/model'
import { useBalance } from '../../navbar/model'
import { ProfileMenuAvatar } from './ProfileMenuAvatar'

const menuItems: { title: string; href: string; icon: IconName; content?: string }[] = [
    {
        title: 'Профиль',
        href: '/app/profile/user',
        icon: 'user-square',
        content: '',
    },
    {
        title: 'Организация',
        href: '/app/profile/org',
        icon: 'briefcase',
        content: '',
    },
    {
        title: 'Баланс и оплата',
        href: '/app/profile/payment',
        icon: 'empty-wallet',
        content: '',
    },
    {
        title: 'Интеграция с МП',
        href: '/app/profile/integrations',
        icon: 'shopping-cart',
        content: '',
    },
    {
        title: 'История платежей и затрат',
        href: '/app/profile/payment-history',
        icon: 'task-square',
    },
    {
        title: 'Написать в поддержку',
        href: '/app/profile/support',
        icon: 'user-square',
    },
    {
        title: 'Юридическая информация',
        href: '/app/profile/legal',
        icon: 'verify',
    },
]

type ProfileMenuProps = {
    topSlot?: React.ReactNode
}

export const ProfileMenu = ({ topSlot }: ProfileMenuProps) => {
    const { data: currentOrg } = useCurrentOrg()
    const { me } = useMe()

    return (
        <div className='space-y-[1.25rem]'>
            <ProfileMenuAvatar placeholder={currentOrg?.name} imageUrl={me?.avatar_url ?? undefined} />

            <h3 className='text-[24px]/[26px]'>{currentOrg?.name}</h3>
            {topSlot}

            <Menu className='flex w-full flex-col flex-nowrap p-0'>
                {menuItems.map(item => (
                    <MenuItem key={item.href}>
                        <NavLink to={item.href} className={({ isActive }) => (isActive ? 'menu-active' : '')}>
                            <Icon name={item.icon} size='lg' /> {item.title}
                        </NavLink>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}

export const NavbarMenuModals = () => {
    return (
        <>
            <Modal id='orgChangeModal'>
                <SelectOrg />
            </Modal>
            <Modal id='addOrgModal'>
                <h3 className='text-lg font-bold'>Добавить организацию</h3>
                <AddOrgForm />
            </Modal>
        </>
    )
}

export const NavbarProfileDropdownMenu = () => {
    const { me } = useMe()
    const { data: currentOrg } = useCurrentOrg()
    const logoutMutation = useLogout()
    useMyOrgs()
    const { data: balance } = useBalance(currentOrg?.id)

    if (me) {
        menuItems[0].content = `${me?.last_name ?? ''} ${me?.first_name ?? ''}`
    }

    if (currentOrg) {
        menuItems[1].content = currentOrg.name ?? ''
    }

    if (balance) {
        menuItems[2].content = `${balance.total || '0'} Токенов`
    }

    const logoutHandler = (e: React.FormEvent) => {
        e.preventDefault()
        logoutMutation.mutate()
    }

    return (
        <DropdownMenu className='menu dropdown-content shadow-sm w-[300px] max-w-[300px]'>
            {menuItems.map(item => (
                <MenuItem key={item.href}>
                    <div className='flex flex-start p-0!'>
                        <NavLink
                            to={item.href}
                            className={({ isActive }) =>
                                isActive
                                    ? 'menu-active flex-1 py-[15px] px-[20px] pr-[50px] w-full'
                                    : 'flex-1 py-[15px] px-[20px] pr-[50px] w-full'
                            }
                        >
                            <div className='flex flex-col items-start overflow-hidden'>
                                <span>{item.title}</span>
                                {item.content && (
                                    <div className='overflow-hidden w-full'>
                                        <div className='menu-about truncate'>{item.content}</div>
                                    </div>
                                )}
                            </div>
                        </NavLink>
                        {item.href === '/app/profile/org' && (
                            <Button
                                as='label'
                                variant='ghost'
                                size='lg'
                                emphasis='secondary'
                                className='absolute right-0'
                                title='Сменить организацию'
                                htmlFor='orgChangeModal'
                            >
                                <Icon name='repeat' size='lg' />
                            </Button>
                        )}
                    </div>
                </MenuItem>
            ))}
            {me?.is_admin && (
                <>
                    <MenuDivider />
                    <MenuItem>
                        <div className='flex flex-start p-0!'>
                            <a href='/admin' className='flex-1 py-[15px] px-[20px] pr-[50px] w-full'>
                                <div className='flex flex-col items-start overflow-hidden'>
                                    <span>Администрирование</span>
                                </div>
                            </a>
                        </div>
                    </MenuItem>
                </>
            )}
            <MenuDivider />
            <MenuItem>
                <div className='flex flex-start p-0!'>
                    <a className='flex-1 py-[15px] px-[20px] pr-[50px] w-full' onClick={logoutHandler}>
                        <div className='flex flex-col items-start overflow-hidden'>
                            <span>Выйти из аккаунта</span>
                        </div>
                    </a>
                </div>
            </MenuItem>
        </DropdownMenu>
    )
}

export const NavbarMenu = () => {
    return (
        <>
            <NavbarProfileDropdownMenu />
            <NavbarMenuModals />
        </>
    )
}
